export type Intent = 'primary' | 'warning' | 'error' | 'success' | 'lightSuccess' | 'default' | 'neutral'
export type Size = 'xs' | 's' | 'm' | 'l'

export const theme = {
  color: {background: '#f7f7f7', gray: '#b3b3b3', contentBackground: '#f2f2f2', red: '#dc0000', darkGray: '#999', white: '#fff'},
  fontSize: {xsmall: '1.3rem', small: '1.6rem', medium: '1.8rem', large: '2rem', xlarge: '3.2rem', header: '5rem'},
  fontSizePx: {small: '14px', medium: '16px'},
  font: {text: "'Encode Sans Condensed', sans-serif", header: "'Encode Sans Condensed', sans-serif"},
  layout: {maxWidth: 950, mobileContentPadding: '1rem 2rem'},
  breakPoints: {mobileMax: 480, mobilePortrait: 360, mobileLandscape: 768},
  fontWeight: {normal: 400, bolder: 500, bold: 700}
}

export const adminColors = {
  color: {
    textLightest: '#c0c0c0',
    textLight: '#AAA',
    textDark: '#444',
    textInverse: '#fff',
    bg: '#fff',
    white: '#fff',
    primary: '#a04191',
    secondary: '#666666',
    error: '#ffe2e2',
    darkError: '#dd1313',
    darkWarning: '#eda323',
    warning: '#fcf1c7',
    success: '#59B259',
    lightSuccess: '#d4e8c0',
    lightGray: '#e6ecf5',
    sudle: '#4f899f',
    black: '#000000'
  }
}

export function raise(level: number): string {
  switch (level) {
    case 1:
      return 'box-shadow: 0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24);'
    case 2:
      return 'box-shadow: 0 3px 6px rgba(0,0,0,0.16), 0 3px 6px rgba(0,0,0,0.23);'
    case 3:
      return 'box-shadow: 0 10px 20px rgba(0,0,0,0.19), 0 6px 6px rgba(0,0,0,0.23);'
    case 4:
      return 'box-shadow: 0 14px 28px rgba(0,0,0,0.25), 0 10px 10px rgba(0,0,0,0.22);'
    case 5:
      return 'box-shadow: 0 19px 38px rgba(0,0,0,0.30), 0 15px 12px rgba(0,0,0,0.22);'
    default:
      return ''
  }
}

export function getBackgroundColor(type: Intent) {
  switch (type) {
    case 'error':
      return adminColors.color.error
    case 'primary':
      return adminColors.color.primary
    case 'success':
      return adminColors.color.success
    case 'lightSuccess':
      return adminColors.color.lightSuccess
    case 'warning':
      return adminColors.color.warning
    case 'neutral':
      return '#fff'
    default:
      return adminColors.color.textLight
  }
}

export function getColor(type: Intent) {
  switch (type) {
    case 'lightSuccess':
      return 'rgb(8, 120, 61)'
    case 'neutral':
      return adminColors.color.textDark
    default:
      return adminColors.color.textInverse
  }
}

export function getFontSize(size: Size) {
  switch (size) {
    case 's':
      return 13
    case 'm':
      return 14
    case 'l':
      return 16
    default:
      return 14
  }
}
